import { useContext, useMemo } from 'react';
import SiteContext from '../components/contexts/SiteProvider';
import type { SiteData, UseSiteDataType } from '../types/siteData.types';
export const useSiteData = (): UseSiteDataType => {
  const siteData: SiteData | undefined = useContext(SiteContext);
  if (!siteData) {
    throw new Error('useSiteData must be used within a SiteContext provider');
  }
  const {
    auth,
    buyItAgain,
    country,
    featureControls,
    fragmentName,
    nav,
    tenantEnvironment,
    uiLocalization,
    uxMods = [],
    vistacartTenantName: vistacartTenant,
  } = siteData;

  return useMemo(() => {
    const { locale } = uiLocalization;

    // add fallback for nested properties
    const allowAnonymous = auth?.allowAnonymous || false;

    // build URL for Embroidery Guidelines
    const embroideryUrl = `${nav?.helpCenter}14808582054925/`;

    const navDefaults = {
      cart: `/c/`,
      checkout: `/co/`,
      orderConfirmation: `/od/`,
      orderDetails: `/od/`,
      orderHistory: `/oh/`,
    };

    const navOverrides = {};

    return {
      allowAnonymous,
      buyItAgain,
      country,
      embroideryUrl,
      externalAppNavigation: { ...navDefaults, ...nav, ...navOverrides },
      featureControls,
      fragmentName,
      locale,
      siteName: fragmentName,
      tenantEnvironment,
      uiLocalization,
      uxMods,
      vistacartTenant,
    };
  }, [
    auth?.allowAnonymous,
    buyItAgain,
    country,
    featureControls,
    fragmentName,
    nav,
    tenantEnvironment,
    uiLocalization,
    uxMods,
    vistacartTenant,
  ]);
};
